import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CheckboxQuestion } from '../../../classes/question-checkbox';

@Component({
  selector: 'bepatient-input-checkbox',
  templateUrl: './input-checkbox.component.html',
  styleUrls: ['./input-checkbox.component.scss'],
  standalone: false
})
export class InputCheckboxComponent {
  @Input() question: CheckboxQuestion;
  @Input() parent: UntypedFormGroup;
}
